// true if use local backend, false if use heroku
var local = false;
var urlHTTP = 'https://rs-lang-team17-be.herokuapp.com';
var urllocal = 'http://localhost:4000';
export var urlAPI = local ? urllocal : urlHTTP;
